import { render, staticRenderFns } from "./UploadDialog.vue?vue&type=template&id=c65b1fec&"
import script from "./UploadDialog.vue?vue&type=script&lang=ts&"
export * from "./UploadDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports